import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function CookieConsent() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const cookieChoice = localStorage.getItem('cookieChoice');
    if (!cookieChoice) {
      setIsVisible(true);
    }
  }, []);

  const handleChoice = (choice) => {
    localStorage.setItem('cookieChoice', choice);
    setIsVisible(false);
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div className="cookie-consent">
      <h3>Informasjon om informasjonskapsler</h3>
      <p>
        Denne nettsiden bruker informasjonskapsler for å forbedre din opplevelse.
        Vi bruker informasjonskapsler for analyse og for å tilpasse innhold og annonser.
        Ved å klikke godtar du vår bruk av informasjonskapsler. Les mer i vår
        <Link to="/privacy-policy" className="cookie-link"> personvernpolicy</Link>.
      </p>
      <div className="cookie-buttons">
        <button className="cookie-button cookie-accept" onClick={() => handleChoice('accepted')}>
          Godta alle
        </button>
        <button className="cookie-button cookie-customize" onClick={() => handleChoice('customized')}>
          Tilpass
        </button>
        <button className="cookie-button cookie-deny" onClick={() => handleChoice('denied')}>
          Avslå
        </button>
      </div>
    </div>
  );
}

export default CookieConsent;